// This logic was original created for Private Collections; it is also applied to Private Products.
// To save repeated JS & CSS, elements and classes have not be renamed.
// PDP features references to 'collection' as a result, but the data is obtained from PRODUCT Metatfields.
import { docReady } from '../helpers/doc-ready';
docReady(() => {
    const privateCollection = document.querySelector('[data-private-collection]'), privateCollectionID = privateCollection === null || privateCollection === void 0 ? void 0 : privateCollection.getAttribute('data-private-collection-id'), privateCollectionKey = privateCollection === null || privateCollection === void 0 ? void 0 : privateCollection.getAttribute('data-private-collection-key'), passwordControl = privateCollection === null || privateCollection === void 0 ? void 0 : privateCollection.querySelector('collection-password'), passwordControlFullPage = passwordControl === null || passwordControl === void 0 ? void 0 : passwordControl.classList.contains('collection-password--full-page'), passwordControlSubmitButton = passwordControl === null || passwordControl === void 0 ? void 0 : passwordControl.querySelector('[data-submit-password]'), protectedContent = privateCollection === null || privateCollection === void 0 ? void 0 : privateCollection.querySelector('[data-protected-content]'), accessGranted = privateCollection === null || privateCollection === void 0 ? void 0 : privateCollection.querySelector('access-granted');
    if (privateCollection && privateCollectionID && privateCollectionKey && passwordControl && passwordControlSubmitButton && protectedContent) {
        const passwordInputWrapper = passwordControl.querySelector('.form-control'), passwordInput = passwordControl.querySelector('#collection-password');
        const checkStatus = () => {
            const privateStatus = localStorage.getItem('private-collection-' + privateCollectionID) || 'locked';
            if (privateStatus == 'locked') {
                passwordControl.classList.remove('collection-password--hidden');
                protectedContent.classList.add('collection--hidden');
                accessGranted === null || accessGranted === void 0 ? void 0 : accessGranted.classList.add('access-granted--hidden');
                if (passwordControlFullPage) {
                    window.onbeforeunload = () => {
                        window.scrollTo(0, 0);
                    };
                    document.body.setAttribute('style', 'overflow: hidden;');
                }
            }
            else if (privateStatus == 'unlocked') {
                privateCollection.setAttribute('data-private-collection-unlocked', 'true');
                passwordControl.classList.add('collection-password--hidden');
                protectedContent.classList.remove('collection--hidden');
                accessGranted === null || accessGranted === void 0 ? void 0 : accessGranted.classList.remove('access-granted--hidden');
                document.body.setAttribute('style', 'overflow: scroll;');
            }
        };
        checkStatus();
        const submitPassword = () => {
            let passwordValue = passwordInput.value;
            passwordValue = passwordValue.toLowerCase();
            if (passwordValue == privateCollectionKey) {
                localStorage.setItem('private-collection-' + privateCollectionID, 'unlocked');
            }
            else {
                passwordInputWrapper.classList.add('form-control--shake', 'form-control--error');
                setTimeout(() => {
                    passwordInputWrapper.classList.remove('form-control--shake', 'form-control--error');
                }, 500);
            }
        };
        passwordInput.addEventListener('keypress', (e) => {
            const key = e.key;
            if (key == 'Enter' || e.which == 13) {
                submitPassword();
                checkStatus();
            }
        });
        passwordControlSubmitButton.addEventListener('click', () => {
            submitPassword();
            checkStatus();
        });
    }
});
